<template>
    <div class="container">
        <div class="bg_fff header_box">
            <span class="fs12">导出选择</span>
            <mt-radio class="flex_box fs14 co_333 mt10" v-model="exportOption" :options="exportOptions"></mt-radio>

        </div>
        <div class="main">
            <div class="list">
                <p class="fs12 co_ff4 commonTitle ml16">接收邮箱</p>
                <section>
                    <div class="itemList flex_box  align-items_center justify-content_flex-justify ml10"
                         v-for="item in emailList" :key="item._id">
                        <div @click="chooseEmail(item)" class="flex_box align-items_center">
                            <img :src="item.isChoose ? selectImagePaht : defaulfImagePaht"
                                 :alt="item.isChoose ? '已选择' : '未选择' "/>
                            <p class="addreStr elli1 fs16">{{ item.addreStr }}</p>
                        </div>
                        <div>
                            <a class="edit_btn" @click="addEmail(item.addreStr, item._id)">编辑</a>
                            <a class="delete_btn" @click="deleteEmail(item._id)">删除</a>
                        </div>
                    </div>
                </section>
                <div :class="['addEmail', 'ml16', {inActive: emailList.length >= 10}]" @click="addEmail()">
                    <img class="addIcon" src="../assets/img/export/addIcon.png" alt="添加">
                    <span class="fs16 text ml8">添加新邮箱</span>
                </div>
            </div>

            <div class="select_box bg_fff ml16">
                <p class="fs12 co_ff4 commonTitle">报告格式</p>
                <mt-radio class="flex_box fs14 co_333 mt10" v-model="exportType" :options="exportTypes"></mt-radio>
            </div>
        </div>
        <div class="confirmBtn">
            <a class="fs18 co_fff " href="javascript:;" @click="confirmExport()">确认</a>
        </div>
        <!-- 导出结果弹窗 -->
        <section class="popupBg text_c" v-if="showResult" @click="close()">
            <img v-if="showResult === 'success'" src="../assets/img/export/success.png" alt="导出成功">
            <img v-if="showResult === 'failed'" src="../assets/img/export/failed.png" alt="导出失败">
        </section>
        <!-- loading box -->
        <section class="loadingBg" v-if="processing">
            <mt-spinner type="double-bounce" color="#26a2ff"></mt-spinner>
        </section>
        <LoadingPage :loading="loading"/>

    </div>
</template>

<script>
import req from "@/util/request"
import _co from "@/util/const"
import _ from "loadsh";

export default {
    name: 'Export',
    components: {
        LoadingPage(render) {
            require(["@/components/common/LoadingPage"], render)
        },
    },
    data() {
        return {
            defaulfImagePaht: require("../assets/img/export/noChoose.png"),
            selectImagePaht: require("../assets/img/export/hasChoose.png"),
            emailList: [],
            chooseList: [],
            exportOptions: _co.exportOptions,
            exportOption: "email",
            exportTypes: [],
            exportType: '',
            typeMap: {
                'png': 'png',
                'PPT': 'PPT',
                'excel': 'excel'
            },
            sendMailData: {},
            processing: false,
            showResult: false,
            loading: true,
        }
    },
    mounted() {
        let {page} = this.$route.query;
        this.initExportOption(page);
        this.getEmailList();
    },
    methods: {
        getEmailList: async function () {
            let data = await req.get('/api/address');
            data.report.forEach(item => {
                item.isChoose = false;
            })
            this.emailList = data.report;
            this.loading = false;
        },
        chooseEmail: function (item) {
            item.isChoose = !item.isChoose;
            if (item.isChoose) {
                this.chooseList.push(item)
            } else {
                this.chooseList = this.chooseList.filter(element => element._id !== item._id)
            }
        },
        async addEmail(inputValue = "", id) {
            let option = {
                inputPlaceholder: "请输入接收报告/数据的邮箱",
                confirmButtonText: '立即添加',
                // showConfirmButton: true,
                showCancelButton: true,
                inputValidator: (content) => {
                    if (!(/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(content))) {
                        return "邮箱格式错误";
                    }
                },
            }
            if (id) {
                option.inputValue = inputValue;
            }
            let {value: content} = await this.$messagebox.prompt(' ', `${id ? '编辑邮箱' : '创建邮箱'}`, option);
            if (id) {
                await req.eidtAddress(id, {addreStr: content})
            } else {
                await req.createAddress({
                    'usageType': 'report',
                    'type': 'email',
                    'addreStr': content,
                })
            }

            location.reload();

        },
        confirmExport: async function () {
            if (this.processing)
                return;
            if (!this.chooseList.length || !this.typeMap[this.exportType]) {
                this.$messagebox({
                    title: '',
                    message: '请选择邮箱和导出格式'
                })
                return;
            }
            this.sendEmailData = JSON.parse(sessionStorage.getItem("sendEmailData"));
            if (this.exportType == "PPT") {
                this.sendEmailData = {
                    subject: this.sendEmailData.subject,
                    pptData: JSON.parse(sessionStorage.getItem("sendEmailPptData"))
                }
            }else if(this.exportType == "png"){
                let {data: imageData} = JSON.parse(sessionStorage.getItem('imageData'));
                this.sendEmailData.imageData = imageData;
            }

            if (!this.sendEmailData) {
                this.showResult = 'failed';
                return;
            }
            this.processing = true;
            this.sendEmailData.selectEmails = _.map(this.chooseList, "addreStr");
            this.sendEmailData.exportType = this.exportType;
            let data = null;
            try {
                data = await req.sendEmail(this.sendEmailData);
            } catch (err) {
                this.showResult = 'failed';
                return;
            }
            this.processing = false;
            if (data && typeof data == 'string' && data == 'confirm') {
                this.showResult = 'failed';
                return;
            }
            this.showResult = 'success';
        },
        close: function () {
            this.showResult = false;
            history.go(-1);
        },
        // 处理不同类型展示
        initExportOption: function (page) {
            this.exportTypes = _.filter(_co.exportTypes, e => {
                return ~e.pages.indexOf(page)
            })
            
            this.exportType = _co.defaultPageExportType[page]
        },
        async deleteEmail(id) {
            let resp = await this.$messagebox.confirm('确定要删除么？')
            if (resp && resp == "confirm") {
                await req.deleteAddress(id)
                location.reload();
            }

        }
    }
}
</script>

<style lang="scss" scoped>
.container {
    width: 100vw;
    height: 100vh;
    //background-color: #d9d9d9;
    margin: 0 0;
    position: absolute;

    .header_box {
        height: 76px;
        padding: 16px;

        span {
            font-family: PingFangSC-Regular;
            color: #B0B0B0;
            letter-spacing: 0;
            line-height: 16px;
            font-weight: 400;
        }
    ;
    }

    .main {
        .list {
            margin: 10px 16px 10px 16px;
            background-color: #ffffff;

            .addEmail {
                height: 48px;
                display: flex;
                align-items: center;

                .addIcon {
                    width: 24px;
                    height: 23.75px;
                    vertical-align: middle;
                }

                .text {
                    font-family: PingFangSC-Regular;
                    color: #538DFF;
                    line-height: 20px;
                    font-weight: 400;
                }
            }

            .addEmail.inActive {
                pointer-events: none;
                opacity: 0.5;
            }

            .itemList {
                font-family: PingFangSC-Regular;
                height: 48px;
                border-bottom: 1px solid #EDEDED;
                font-size: 16px;
                color: #333333;
                letter-spacing: 0;
                font-weight: 400;
                margin-left: 16px;
                margin-right: 16px;

                img {
                    width: 18px;
                    height: 18px;
                    vertical-align: middle;
                    border: 1px solid #EDEDED;
                    margin-right: 8px;
                }

                .addreStr{
                    width: 210px;
                }
                a {
                    font-size: 14px;
                    letter-spacing: 0;
                    text-align: center;
                    line-height: 20px;
                    font-weight: 400;
                }

                a:nth-child(1) {
                    color: #3D8FFF;
                    margin-right: 12px;
                }

                a:nth-child(2) {
                    color: #F85459;
                }


            }
        }

        .list.exportType {
            .commonTitle {
                border-bottom: none;
            }
        }
    }

    .confirmBtn {
        margin-top: 100px;
        height: 48px;
        a{
            width: 100%;
            position: fixed;
            bottom: 0;
            background-color: #538DFF;
            text-align: center;
            line-height: 48px;

        }
    }

    .popupBg img {
        width: 300px;
        margin-top: calc((100vh - 200px) / 2);
    }

    .commonTitle {
        font-family: PingFangSC-Regular;
        color: #B0B0B0;
        letter-spacing: 0;
        line-height: 42px;
        font-weight: 400;
        height: 42px;
        //border-bottom: 1px solid #EDEDED;
    }

    .select_box {
        margin: 8px auto;
        //padding: 16px 16px 32px;
        padding: 0px 16px 16px 16px;
        border-radius: 4px;
        margin-left: 16px;
        margin-right: 16px;
    }
}
</style>